import { useAppSelector } from 'store'
import { AppSelectors } from 'store/app'

export const useIsAppInitialized = (): boolean => useAppSelector(AppSelectors.isInitialized())
